<h3 class="md-subhead">Replace Gridics Ids Statistic:</h3>
<table class="mdl-data-table mdl-js-data-table mdl-shadow--2dp monitoring-table">
    <thead>
        <tr>
            <th style="width: 40%" class="header-cell">Entity</th>
            <th style="width: 20%" class="header-cell">Old</th>
            <th style="width: 20%" class="header-cell">Updated</th>
            <th style="width: 20%" class="header-cell">New</th>
        </tr>
    </thead>
    <tbody>
        <tr class="data-row">
            <td class="value-cell">Zoning Codes</td>
            <td class="value-cell">{{replaceLandUseStatistic.oldIdZCCount}}</td>
            <td class="value-cell">{{replaceLandUseStatistic.updatedZCRecordsCount}}</td>
            <td class="value-cell">{{replaceLandUseStatistic.newIdZCCount}}</td>
        </tr>
        <tr class="data-row">
            <td class="value-cell">Zoning Code Versions</td>
            <td class="value-cell">{{replaceLandUseStatistic.oldIdZCVCount}}</td>
            <td class="value-cell">{{replaceLandUseStatistic.updatedZCVRecordsCount}}</td>
            <td class="value-cell">{{replaceLandUseStatistic.newIdZCVCount}}</td>
        </tr>
        <tr class="data-row">
            <td class="value-cell">Property Record Places</td>
            <td class="value-cell">{{replaceLandUseStatistic.oldIdPRsPlaceCount}}</td>
            <td class="value-cell">{{replaceLandUseStatistic.updatedPRsPlaceCount}}</td>
            <td class="value-cell">{{replaceLandUseStatistic.newIdPRsPlaceCount}}</td>
        </tr>
        <tr class="data-row">
            <td class="value-cell">Property Record Land Uses</td>
            <td class="value-cell">{{replaceLandUseStatistic.oldIdPRsLandUseCount}}</td>
            <td class="value-cell">{{replaceLandUseStatistic.updatedPRsLandUseCount}}</td>
            <td class="value-cell">{{replaceLandUseStatistic.newIdPRsLandUseCount}}</td>
        </tr>
        <tr class="data-row">
            <td class="value-cell">Property Record Zoning Codes</td>
            <td class="value-cell">{{replaceLandUseStatistic.oldIdPRsZoningCodeIdCount}}</td>
            <td class="value-cell">{{replaceLandUseStatistic.updatedPRsZoningCodeIdCount}}</td>
            <td class="value-cell">{{replaceLandUseStatistic.newIdPRsZoningCodeIdCount}}</td>
        </tr>
    </tbody>
</table>